<template>
  <div v-if="isVisible" id="lm-leaflet-map" :style="{ height }">
    <l-map
      style="height: 100%; width: 100%"
      :zoom="Number(zoom)"
      :center="centerMapCoordinateComputed"
      :options="options"
    >
      <l-tile-layer :url="tile" />
      <l-marker v-if="markerLatLng.length" :lat-lng="markerLatLng" ></l-marker>
      <div
        v-for="(item, index) of multiMarkerLatLng"
        :key="index"
      >
        <l-marker v-if="item.length" :lat-lng="item" >
          <l-tooltip
            v-if="multiTooltipLatLng.length"
            :options="{ interactive: true }"
          >
            <div>
              {{multiTooltipLatLng[index]}}
            </div>
          </l-tooltip>
        </l-marker>
      </div>
      <div
        v-for="(item, index) of markerObjects"
        :key="index"
      >
        <l-marker v-if="item.location.length" :lat-lng="item.location" >
          <l-icon v-if="item.icon"
            :icon-url="item.icon.iconUrl"
            :shadow-url="item.icon.shadowUrl"
            :icon-size = "[25, 41]"
            :icon-anchor = "[12, 41]"
            :popup-anchor = "[1, -34]"
            :shadow-size = "[41, 41]"
          >
          </l-icon>
          <l-tooltip
            v-if="item.tooltip"
            :options="{ interactive: true }"
          >
            <div>
              {{item.tooltip}}
            </div>
          </l-tooltip>
          <l-popup v-if="item.popup">
            <span v-html="item.popup.text"></span>
            <span v-for="(link, index) of item.popup.links" :key="index">
              <router-link v-if="link.type === 'router'" :to="link.to" class="d-flex">
                <span v-if="link.label">{{link.label}}</span>
                <i v-if="link.icon" class="mdi" :class="`mdi-${link.icon}`"></i>
              </router-link>
              <a v-if="link.type === 'ahref'" :href="link.to" :target="link.target" class="d-flex">
                <span v-if="link.label">{{link.label}}</span>
                <i v-if="link.icon" class="mdi" :class="`mdi-${link.icon}`"></i>
              </a>
            </span>
          </l-popup>
        </l-marker>
      </div>
      <l-geo-json
        v-if="enableGeoJson"
        :geojson="geojson"
        :options="geoOptions"
        :options-style="styleFunction"
      />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LTooltip, LGeoJson, LIcon, LPopup } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  data () {
    return {
      defaultLocation: process.env.VUE_APP_DEFAULT_GEOLOCATION ? process.env.VUE_APP_DEFAULT_GEOLOCATION.split(',').map(i => parseFloat(i)) : [-34.6037389, -58.3815704]
    }
  },
  components: {
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker,
    LTooltip,
    LGeoJson,
    LIcon,
    LPopup
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: () => ({ scrollWheelZoom: false })
    },
    tile: {
      type: String,
      default: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png'
    },
    markerLatLng: {
      type: Array,
      default: () => []
    },
    enableGeoJson: {
      type: Boolean,
      default: false
    },
    geojson: {
      type: Object,
      default: () => {}
    },
    geojsonEnableTooltips: {
      type: Boolean,
      default: false
    },
    geojsonLabelTooltip: {
      type: String,
      default: ''
    },
    geojsonFeaturePropertyTooltip: {
      type: String,
      default: ''
    },
    markerObjects: {
      type: Array,
      default: () => []
    },
    multiMarkerLatLng: {
      type: Array,
      default: () => []
    },
    multiTooltipLatLng: {
      type: Array,
      default: () => []
    },
    centerMapCoordinate: {
      type: Array,
      default: () => this?.defaultLocation
    },
    zoom: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: String,
      default: '400px'
    },
    fillColor: {
      type: String,
      default: '#e4ce7f'
    }
  },
  computed: {
    geoOptions () {
      return {
        onEachFeature: this.onEachFeatureFunction
      }
    },
    styleFunction () {
      const fillColor = this.fillColor // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 2,
          color: '#ECEFF1',
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1
        }
      }
    },
    onEachFeatureFunction () {
      if (!this.geojsonEnableTooltips) {
        return () => {}
      }
      return (feature, layer) => {
        layer.bindTooltip(
          `<div>${this.geojsonLabelTooltip} ${feature.properties[this.geojsonFeaturePropertyTooltip]}</div>`,
          { permanent: false, sticky: true }
        )
      }
    },
    centerMapCoordinateComputed () {
      if (this.centerMapCoordinate?.length) {
        return this.centerMapCoordinate
      } else {
        if (this.multiMarkerLatLng.length) {
          return this.multiMarkerLatLng[0]
        } else if (this.markerObjects.length) {
          return this.markerObjects[0]
        } else {
          return this.defaultLocation
        }
      }
    }
  }
}
</script>
